import script from "./ml-select.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-select.vue?vue&type=script&setup=true&lang=js"

import "./ml-select.vue?vue&type=style&index=0&id=68171fa0&lang=scss"

const __exports__ = script;

export default __exports__